// src/hooks/useSettings.js
import { useState, useCallback } from "react";

export const useSettings = (defaultSettings, validationRules = {}) => {
  const [settings, setSettings] = useState(defaultSettings);
  const updateSetting = useCallback((key, value) => {
    setSettings((prev) => ({ ...prev, [key]: value }));
  }, []);

  const updateMultipleSettings = useCallback((newSettings) => {
    setSettings((prev) => ({ ...prev, ...newSettings }));
  }, []);

  const resetSettings = useCallback(() => {
    setSettings(defaultSettings);
  }, [defaultSettings]);

  const validateSettings = useCallback(() => {
    const errors = [];

    Object.entries(validationRules).forEach(([key, rules]) => {
      const value = settings[key];

      if (
        rules.required &&
        (!value ||
          value === "" ||
          (typeof value === "number" &&
            value === 0 &&
            rules.allowZero !== true))
      ) {
        errors.push(`${rules.label || key} is required`);
      }

      if (rules.min !== undefined && value !== "" && value !== null && value !== undefined && value < rules.min) {
        errors.push(`${rules.label || key} must be at least ${rules.min}`);
      }

      if (rules.max !== undefined && value !== "" && value !== null && value !== undefined && value > rules.max) {
        errors.push(`${rules.label || key} must be at most ${rules.max}`);
      }

      if (rules.custom && typeof rules.custom === "function") {
        const customError = rules.custom(value, settings);
        if (customError) errors.push(customError);
      }
    });

    // Cross-field validations
    if (
      settings.minRead &&
      settings.maxRead &&
      settings.minRead > settings.maxRead
    ) {
      errors.push("Min Read must be less than Max Read");
    }

    return { isValid: errors.length === 0, errors };
  }, [settings, validationRules]);

  return {
    settings,
    updateSetting,
    updateMultipleSettings,
    resetSettings,
    validateSettings,
  };
};
